import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rn3_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const lang = localStorage.getItem("rn3.lang") || "en";
  config.headers["X-Lang"] = lang;
  return config;
});

export const SERVICES = [
  {
    key: "bookkeeping",
    title: "Bookkeeping Services",
    short: "Organized books, every month.",
    desc: "Monthly reconciliation, categorization, and clean financial records that help you make confident decisions.",
    docs: ["Bank statements (PDF/CSV)", "Receipts", "Last year's books (if any)", "Chart of accounts"],
  },
  {
    key: "tax_prep",
    title: "Tax Preparation",
    short: "Individuals, families, and small businesses.",
    desc: "Accurate, on-time tax preparation with deduction guidance for personal and business returns.",
    docs: ["W-2 / 1099 forms", "Prior year return", "ID & SSN/ITIN", "Receipts & deduction records"],
  },
  {
    key: "sales_tax",
    title: "Sales Tax Reporting",
    short: "Filed correctly. Filed on time.",
    desc: "Monthly or quarterly sales tax filings tailored to your jurisdiction and business structure.",
    docs: ["Sales reports", "POS export", "Sales tax permit", "Exempt sales documentation"],
  },
  {
    key: "notary",
    title: "Notary Services",
    short: "In-person & mobile notarization.",
    desc: "Acknowledgments, jurats, affidavits, and personal documents — quickly and professionally.",
    docs: ["Valid government-issued ID", "Document to be notarized (unsigned)"],
  },
  {
    key: "loan_signing",
    title: "Loan Signing Agent",
    short: "Certified loan document signings.",
    desc: "Professional loan document signings for refinances, purchases, HELOCs, and reverse mortgages.",
    docs: ["Loan document package", "Valid ID for all signers"],
  },
  {
    key: "itin",
    title: "ITIN Acceptance Agent",
    short: "Apply or renew your ITIN.",
    desc: "Certified Acceptance Agent support so you don't have to mail original documents to the IRS.",
    docs: ["Passport or supporting ID documents", "W-7 form (we help complete)", "Tax return (if filing)"],
  },
  {
    key: "translation",
    title: "Spanish Translation",
    short: "Bilingual documents, done right.",
    desc: "Spanish-English translation of personal, legal, and business documents with a certificate of accuracy.",
    docs: ["Source document (any format)"],
  },
];

export const STATUS_OPTIONS = [
  { key: "new_lead", label: "New Lead" },
  { key: "intake_submitted", label: "Intake Submitted" },
  { key: "documents_needed", label: "Documents Needed" },
  { key: "appointment_scheduled", label: "Appointment Scheduled" },
  { key: "in_review", label: "In Review" },
  { key: "in_progress", label: "In Progress" },
  { key: "completed", label: "Completed" },
  { key: "follow_up_needed", label: "Follow-Up Needed" },
];

export const SOCIAL_LINKS = [
  { name: "Facebook", href: "https://facebook.com", icon: "facebook" },
  { name: "Instagram", href: "https://instagram.com", icon: "instagram" },
  { name: "TikTok", href: "https://tiktok.com", icon: "music" },
  { name: "YouTube", href: "https://youtube.com", icon: "youtube" },
  { name: "LinkedIn", href: "https://linkedin.com", icon: "linkedin" },
];

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_8d4410f5-96b3-4ac7-ad5c-8a23a2562b5c/artifacts/xor9dgk5_ROMAN%20NUMERALS-LOGO-REVISED.png";
export const ADELIS_URL = "https://customer-assets.emergentagent.com/job_8d4410f5-96b3-4ac7-ad5c-8a23a2562b5c/artifacts/5fnvxk4x_ChatGPT%20Image%20Jun%2019%2C%202026%2C%2011_56_31%20PM.png";
